import React from "react";
import { graphql, StaticQuery } from "gatsby";
import { Margin } from "styled-components-spacing";
import Copy from "@nib-components/copy";
import { Stack, Box } from "@nib/layout";
import Accordion from "@nib-components/accordion";

const CourseContributors = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query getContributors {
          legalYaml(context: { eq: "nourish-baby" }) {
            contributors {
              heading
              professionals {
                name
              }
              subHeading
            }
          }
        }
      `}
      render={({ legalYaml: { contributors } }) => {
        return (
          <Margin top={{ xs: 4 }}>
            <Accordion borderTop>
              <Accordion.Item title={contributors.heading}>
                <Box marginBottom={{ xs: 4 }}>{contributors.subHeading}</Box>
                <Stack space={{ xs: 2, md: 4 }}>
                  {contributors.professionals.map((person, index) => (
                    <Copy key={index}>{person.name}</Copy>
                  ))}
                </Stack>
              </Accordion.Item>
            </Accordion>
          </Margin>
        );
      }}
    />
  );
};

export default CourseContributors;
